import {IPFS} from "ipfs-core"
import OrbitDB from "orbit-db"
import Identities from "orbit-db-identity-provider"
import {AppConfig} from "../App.config"
import {Keys} from "../interfaces/keys"

export const getOrbitConfig = async (keys: Keys): Promise<ICreateOptions> => {
  const webIdentity = await Identities.createIdentity({
    type: "Ed25519IdentityProvider",
    keypair: keys.webIpfs
  })
  const desktopIdentity = await Identities.createIdentity({
    type: "Ed25519IdentityProvider",
    keypair: keys.desktopIpfs
  })
  return {
    accessController: {
      write: [
        webIdentity.id,
        desktopIdentity.id,
      ]
    }
  }
}

export const getOrbitAddress = async (orbit: OrbitDB,
                                      dbName: string,
                                      dbType: TStoreType,
                                      orbitConfig?: ICreateOptions
): Promise<string> => {
  const address: { root: string, path: string } = await orbit.determineAddress(
    dbName,
    dbType,
    orbitConfig
  ) as any
  return `/orbitdb/${address.root}/${address.path}`
}

export const notifyUpdate = async (ipfs: IPFS, dbAddress: string) => {
  const msg = new TextEncoder().encode(dbAddress)
  await ipfs.pubsub.publish(AppConfig.orbitTopic, msg)
}

export const notifyPin = async (ipfs: IPFS, cid: string) => {
  const msg = new TextEncoder().encode(cid)
  await ipfs.pubsub.publish(AppConfig.ipfsPinTopic, msg)
}

export const clearIPFSOrbit = async () => {
  const databases = await window.indexedDB.databases()
  for (const db of databases) {
    if (db.name == null) {
      continue
    }
    await window.indexedDB.deleteDatabase(db.name)
  }
}
